export enum MessageTemplateDrawerStatusEnum {
  createWhatsAppTemplate = 'CREATE_WHATSAPP_TEMPLATE',
  createEmailTemplate = 'CREATE_EMAIL_TEMPLATE',
  whatsappTemplateDetails = 'WHATSAPP_TEMPLATE_DETAILS',
  emailTemplateDetails = 'EMAIL_TEMPLATE_DETAILS',
  whatsappTemplatePreview = 'WHATSAPP_TEMPLATE_PREVIEW',
  emailTemplatePreview = 'EMAIL_TEMPLATE_PREVIEW',
}
